import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

export const getIssueCCList = async (uid, rid) => {
    try {
        const res = await axios.get(`${base}/Purchase/Getnewstockissueccs`, { params: { UID: uid, RID: rid } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch Cost Centres'); }
};

export const getIndentsByCC = async (cccode) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetIssueIndentsbyCC`, { params: { CCCode: cccode } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch indents'); }
};

// Returns { CheckIndentType: 'Asset' | 'Other' } — Asset indents skip the item-search stage
// entirely (the cart is already fully populated 1:1 from the indent); Other indents require
// picking an item and staging its lot quantities first.
export const getIndentType = async (indentno) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetNewIndentType`, { params: { Indentno: indentno } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch indent type'); }
};

// ItemCodetext label format is "ItemCode , ItemName , Quantity"
export const getIssueItemCodes = async (cccode, indentno) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetIssueitemcodesbyCC`, { params: { CCCode: cccode, IndentNo: indentno } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch item codes'); }
};

// Per-lot rows (MRR/PO batches) available for one item at one CC/Indent
export const getTempDetails = async (itemcode, cccode, indent) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetNewItemsIssueTempDetails`, { params: { Itemcode: itemcode, CCcode: cccode, Indent: indent } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch item lot details'); }
};

// Stages the assigned quantities from the per-lot rows into the cart (NewStockIssueItemcodeDetails)
export const saveTempItems = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/SaveTempNewItemsIssue`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to add item to issue'); }
};

// The staged cart grid for one CC/Indent — for Asset indents this already contains every
// indent item with nothing to stage manually
export const getCartGrid = async (cccode, indentno) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetViewNewIssueItemsGridView`, { params: { CCcode: cccode, Indentno: indentno } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch issue cart'); }
};

export const deleteCartItem = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/DeleteNewStockIssueItems`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to delete item'); }
};

export const saveIssue = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/SaveNewItemsIssue`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to submit issue'); }
};
